import React, { Suspense, useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MotifLoader } from '@ey-xd/motif-react';
import AppRoutes from '../app_config/routeConfig';
import envConfig from '../app_config/envConfig';
import CartAndComparePopup from '../components/cartAndComparePopup/CartAndComparePopup';
import Footer from '../components/footer/Footer';
import PrivateRoute from '../components/privateRoute/PrivateRoute';
import initConfigurationData from '../store/actions/configurationAction';
import AppConfig from '../app_config/appConfig';
import Gnav from '../components/gnav/Gnav';
import { LOGOUT, SET_CLIENT_DATA_TOGGLE } from '../constants/reducerTypes';
import ErrorModal from '../components/errorModal/errorModal';
import authorize from '../providers/authorize';

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentAppVersion, setCurrentAppVersion] = useState(undefined);
  const authStore = useSelector(state => state.authenticationData);
  const { userDetails } = authStore;
  const currentUser =
    authStore &&
    authStore.userDetails &&
    authStore.userDetails.email &&
    authStore.userDetails.email.toLowerCase();
  const isClientDataAccess = authStore?.userDetails?.isClientDataAccess || false;
  const isLoading = useSelector(state => state.generalData.isLoading);
  const showLazyLoader = true;

  useEffect(() => {
    fetch('/manifest.json')
      .then(response => response.json())
      .then(data => {
        setCurrentAppVersion(data['App Version'] || '');
      })
      .catch();
  }, []);

  // Utility function to check if a value is an object
  const isObject = obj => obj !== null && typeof obj === 'object' && !Array.isArray(obj);

  const hasProperties = obj => isObject(obj) && Object.keys(obj).length > 0;

  useEffect(() => {
    const hasCurrentAppVersion = currentAppVersion != null && currentAppVersion !== undefined;

    const userDataLoaded = hasProperties(userDetails);
    if (hasCurrentAppVersion && userDataLoaded) {
      const localAppVersion = userDetails?.appVersion;
      if (localAppVersion !== currentAppVersion) {
        dispatch({ type: LOGOUT });
        authorize.getTokenAcquireAsync();
      }
    }
  }, [currentAppVersion, userDetails]);

  const checkRedirect = () => {
    let redirectRoute = '';
    if (
      window.sessionStorage.getItem('redirectRoute') &&
      window.sessionStorage.getItem('redirectRoute').length > 0
    ) {
      redirectRoute =
        window.sessionStorage.getItem('redirectRoute').replace &&
        window.sessionStorage.getItem('redirectRoute').replace('#/', '/');
      window.sessionStorage.removeItem('redirectRoute');
    } else if (window.location.hash.indexOf('login') >= 0 || !window.location.hash.split('#/')[1]) {
      redirectRoute = AppConfig.routePaths.home;
    }
    if (redirectRoute) {
      if (Array.isArray(Object.keys(AppConfig.routePaths))) {
        const matchRoute = Object.keys(AppConfig.routePaths).find(routeKey =>
          AppConfig.routePaths[routeKey].includes(redirectRoute.split('?')[0]),
        );
        redirectRoute = matchRoute ? redirectRoute : AppConfig.routePaths.home;
      }
      navigate(redirectRoute, { replace: true });
      // history.replace(redirectRoute);
    }
  };

  // initialize adobe analytics script
  const injectAdobeScript = () => {
    const env = process.env.REACT_APP_ENVIRONMENT_NAME;
    const adobeScript = document.createElement('script');
    adobeScript.innerHTML = `InitializeAdobe();function InitializeAdobe() {adobeAnalytics.environment = "${env}";adobeAnalytics.email = "${currentUser}";adobeAnalytics.hashedUserId = sha256(adobeAnalytics.email);adobeAnalytics.injectAdobePageParametersScript();adobeAnalytics.injectAdobeLaunchScriptreferenceOnPageLoad("${envConfig.adobeSource}");adobeAnalytics.injectFooterCode();}`;
    adobeScript.async = false;
    adobeScript.nonce = '2726c7f26c';
    document.body.appendChild(adobeScript);
  };

  useEffect(() => {
    if (authStore.isAuthenticated) {
      checkRedirect();
      dispatch(initConfigurationData());
      injectAdobeScript();
      window.sessionStorage.setItem('refsrc', window.location.href.toLowerCase());
      dispatch({
        type: SET_CLIENT_DATA_TOGGLE,
        payload: isClientDataAccess,
      });
    }
  }, [authStore.isAuthenticated]);

  return (
    <>
      <div className="App">
        <Gnav />
        <Suspense fallback={<MotifLoader show={showLazyLoader} fullscreen={showLazyLoader} />}>
          <MotifLoader show={isLoading} fullscreen={isLoading} />
          {authStore && authStore.isAuthenticated ? <CartAndComparePopup /> : null}
          <Routes>
            {AppRoutes.map(route => {
              if (route.private) {
                return (
                  <Route element={<PrivateRoute />}>
                    <Route path={route.path} element={route.element} />
                  </Route>
                );
              }
              return <Route path={route.path} key={route.path} element={route.element} />;
            })}
          </Routes>
        </Suspense>
        <ErrorModal />
      </div>
      <Footer />
    </>
  );
}

export default App;
